// extracted by mini-css-extract-plugin
export var aboutUsDescription = "about-us-section-module--about-us-description--6O-YA";
export var aboutUsSection = "about-us-section-module--about-us-section--9P7Ga";
export var boldText = "about-us-section-module--bold-text--KoKGa";
export var button = "about-us-section-module--button--Pbi-E";
export var container = "about-us-section-module--container--TrZBQ";
export var firstParagraphStyles = "about-us-section-module--first-paragraph-styles--4-F4o";
export var goImageContainer = "about-us-section-module--go-image-container--k+nQE";
export var hideOnMobile = "about-us-section-module--hide-on-mobile--OQ+WM";
export var innerWrapper = "about-us-section-module--inner-wrapper--2xOQq";
export var outerWrapper = "about-us-section-module--outer-wrapper--S0XZg";
export var paragraph = "about-us-section-module--paragraph--j1xos";